(() => {
  const init = () => {
    const TESTIMONIALS_SELECTOR = '[data-testimonials-section]';
    const PLAY_PAUSE_BUTTON_SELECTOR = '[data-play-pause-button]';
    const SECTION_VIDEO_SELECTOR = '[data-video-id]';

    const SWIPER_SELECTOR = '[data-swiper]';
    const NEXT_BUTTON_SELECTOR = '[data-testimonials-next-swiper]';
    const PREV_BUTTON_SELECTOR = '[data-testimonials-prev-swiper]';

    document.querySelectorAll(TESTIMONIALS_SELECTOR).forEach((section) => {
      const swiperEl = section.querySelector(SWIPER_SELECTOR);

      new Swiper(swiperEl, {
        loop: false,
        navigation: {
          addIcons: false,
          nextEl: NEXT_BUTTON_SELECTOR,
          prevEl: PREV_BUTTON_SELECTOR,
        },
        pagination: false,
        slidesPerView: 'auto',
        spaceBetween: 0,
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        },
      });

      section.querySelectorAll(SECTION_VIDEO_SELECTOR).forEach((videoWrapper) => {
        videoWrapper.addEventListener('click', (e) => {
          const playButton = videoWrapper.querySelector(PLAY_PAUSE_BUTTON_SELECTOR);
          const video = videoWrapper.querySelector('video');

          section.querySelectorAll('video').forEach((v) => {
            if (v !== video) {
              v.pause();
              const otherBtn = v.closest('.swiper-slide')?.querySelector(PLAY_PAUSE_BUTTON_SELECTOR);
              if (otherBtn) {
                const otherIcon = otherBtn.querySelector('use');
                otherIcon.setAttribute('href', '#play-video');
              }
            }
          });

          const icon = playButton.querySelector('use');
          if (!video.paused && !video.ended || !icon) {
            video.pause();
            icon.setAttribute('href', '#play-video');
            videoWrapper.classList.remove('is-playing');
            return;
          }

          icon.setAttribute('href', '#pause-video');
          const playPromise = video.play();
          videoWrapper.classList.add('is-playing');

          const restore = () => {
            const icon = playButton.querySelector('use');
            icon.setAttribute('href', '#play-video');
            videoWrapper.classList.remove('is-playing');
          };
          video.addEventListener('pause', restore, { once: true });
          video.addEventListener('ended', restore, { once: true });
        });
      });
    });
  };
  
  if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            init();
        });
    } else {
        init();
    }
})();